const getThumbnailTextString = (time, title) => {
  const formattedTime = time ? `(${time})` : ''
  return [title, formattedTime].join(' ').trim()
}

export { getThumbnailTextString }
